<div
    class="modal fade"
    id="{{ id }}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalCenterTitle"
    data-backdrop="static"
    aria-hidden="true"
>
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div class="d-flex justify-content-center confirm-dialog-title">
                    {{ messageDialogTitle }}
                </div>
                <div class="d-flex justify-content-center align-items-center">
                    <div class="flex-column pt-md-3 px-4 centered-content">
                        {{ infoMessage }}
                    </div>
                </div>
                <div class="mt-3 p-1 p-md-4 d-flex justify-content-center">
                    <button
                        type="button"
                        class="btn button-red"
                        data-toggle="modal"
                        data-dismiss="modal"
                        (click)="onOk.emit()"
                    >
                        Ok
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
